import { useState } from "react";
import { useDeleteQuery, useGetQuery } from "../hooks";
import Panel from "./Panel";
import Grid from "./Grid";
import Modal from "./Modal";
import EditButton from "./EditButton";
import PerformedJobAdd from "./PerformedJobAdd";
import PerformedJobEdit from "./PerformedJobEdit";
import ConfirmationModal from "./ConfirmationModal";
import Actions from "./Actions";
import AddButton from "./AddButton";
import DeleteButton from "./DeleteButton";
import { useDataContext } from "../contexts";

export default function PerformedJobCRUD({ submission }) {
  const { getJobById, getMemberUserById } = useDataContext();

  const performedJobsQuery = useGetQuery("performed-jobs", {
    queryParams: { submission: submission.id },
  });
  const deletePerformedJob = useDeleteQuery("performed-jobs");

  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editModalId, setEditModalId] = useState(null);
  const [deleteModalId, setDeleteModalId] = useState(null);

  if (performedJobsQuery.isLoading) {
    return null;
  }

  const submissionUser = getMemberUserById(submission.user);

  return (
    <Panel left="Performed jobs" right={`£${submission.jobsTotal}`}>
      <Grid
        data={performedJobsQuery.data}
        columnsTemplate="justify-between grid-cols-[auto_auto_auto]"
        renderTestId={(performedJob) =>
          `Performed job ${performedJob.name} ${performedJob.datePerformed}`
        }
        columns={[
          { header: "Name", key: "name" },
          {
            header: "Reward",
            render: (performedJob) => {
              const job = getJobById(performedJob.job);
              return job ? `£${job.rewardAmount}` : "-";
            },
          },
          {
            header: "Actions",
            render: (performedJob) => (
              <Actions>
                <EditButton
                  key="edit"
                  onClick={() => setEditModalId(performedJob.id)}
                />
                <DeleteButton
                  key="delete"
                  onClick={() => setDeleteModalId(performedJob.id)}
                />
              </Actions>
            ),
          },
        ]}
      />
      <AddButton className="mt-4" onClick={() => setAddModalOpen(true)} />
      <Modal
        isOpen={addModalOpen}
        onClose={() => setAddModalOpen(false)}
        heading="Add Performed Job"
      >
        <PerformedJobAdd
          user={submissionUser}
          callback={() => {
            setAddModalOpen(false);
          }}
        />
      </Modal>
      <Modal
        isOpen={editModalId !== null}
        onClose={() => setEditModalId(null)}
        heading="Edit Performed Job"
      >
        {editModalId && (
          <PerformedJobEdit
            id={editModalId}
            callback={() => {
              setEditModalId(null);
            }}
          />
        )}
      </Modal>
      <ConfirmationModal
        isOpen={deleteModalId !== null}
        onClose={() => setDeleteModalId(null)}
        heading="Delete Performed Job"
        message="Are you sure you want to delete this performed job?"
        confirmLabel="Delete"
        onConfirm={() => {
          deletePerformedJob.mutate(deleteModalId);
          setDeleteModalId(null);
        }}
      />
    </Panel>
  );
}
